import { render, staticRenderFns } from "./form-fieldset.vue?vue&type=template&id=f9e1022a&scoped=true"
import script from "./form-fieldset.vue?vue&type=script&lang=js"
export * from "./form-fieldset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e1022a",
  null
  
)

export default component.exports